module.exports = __webpack_public_path__ + "img/po1.a8f3add8.jpg";